

import axios from 'axios';
import { getPWAMainMenuUrl, getPWASubMenuUrl } from '../url';
import { getToken, getTokenHeader } from '../../../../screen/auth/action';

export const getPWAMainMenuAction  = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getPWAMainMenuUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getPWASubMenuAction  = async () => {
    return new Promise(async (next) => {
      let token = await getToken();
      await axios
        .get(getPWASubMenuUrl(), getTokenHeader(token))
        .then(async ({ data }) => {
          return next(data);
        })
        .catch((err) => {
          return next({ error: err });
        });
    });
};